import { useState } from 'react';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import dayjs from 'dayjs';
import { AdvanceSearchBox } from 'src/components/checklist/rule/AdvanceSearchBox';
import {
  RuleComposerType,
  RuleTextboxType,
} from 'src/utils/constants/checklist-rules-constants';

interface SearchBoxProp {
  buttonName: string;
  options: string[];
  onSelect: (item: string) => void;
  classNames?: string;
}

const SearchBox = ({
  buttonName,
  options,
  onSelect,
  classNames,
}: SearchBoxProp) => {
  const [textInput, setTextInput] = useState('');
  const [startDate, setStartDate] = useState<Date | null>(null); // GOOD

  const handleSelect = (item: string) => {
    if (item !== '') {
      onSelect(item);
    }
  };

  function handleDateChange(date: Date | null): void {
    const formattedDate = dayjs(date).format('MM/DD/YYYY');
    handleSelect(formattedDate);
    setStartDate(date);
  }

  if (buttonName == 'Text')
    return (
      <div className="relative flex flex-col w-full min-w-full transition-all">
        <label
          htmlFor="rule-text-input"
          className="block text-xs font-semibold tracking-wide text-gray-500 mb-1"
        >
          Enter Value
        </label>
        <div className="flex gap-2">
          <input
            type="text"
            id="rule-text-input"
            data-testid="rule-text-input"
            name="rule-text-input"
            placeholder="Text or number..."
            value={textInput}
            onChange={(e) => setTextInput(e.target.value)}
            className="block w-full rounded-md border-0 py-1 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-900 sm:text-sm sm:leading-6 bg-white min-w-0"
          />
          <button
            onClick={() => handleSelect(textInput)}
            id="btn-rule-text-search"
            data-testid="btn-rule-text-search"
            className="flex items-center justify-center px-4 py-1.5 rounded-md text-sm font-semibold text-blue-700 bg-blue-50 ring-1 ring-inset ring-blue-200 hover:bg-blue-100 transition-all shadow-sm shrink-0 whitespace-nowrap"
          >
            Add
          </button>
        </div>
      </div>
    );

  if (buttonName == 'Date') {
    return (
      <div className="relative flex flex-col min-w-full">
        <label
          htmlFor="rule-date-picker"
          className="block text-xs font-semibold  tracking-wide text-gray-500 mb-1 min-w-full"
        >
          Select Date
        </label>
        <DatePicker
          selected={startDate}
          onChange={(date) => handleDateChange(date)}
          dateFormat="MM/dd/yyyy"
          placeholderText="Select Date"
          id="rule-date-picker"
          data-testid="rule-date-picker"
          name="rule-date-picker"
          className="block w-full rounded-md border-0 py-1.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-900 sm:text-sm sm:leading-6 bg-white outline-none"
          wrapperClassName="w-full"
        />
      </div>
    );
  }

  return (
    <div
      className={`relative flex flex-col w-full min-w-full transition-all ${classNames || ''}`}
    >
      <label className="block text-xs font-semibold  tracking-wide text-gray-500 mb-1 min-w-full">
        {RuleTextboxType[buttonName as keyof typeof RuleComposerType]}
      </label>
      <div className="relative w-full shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-gray-900 rounded-md bg-white">
        <AdvanceSearchBox
          data={options}
          dropSize="min-h-40 max-h-40"
          placeholder={
            RuleComposerType[buttonName as keyof typeof RuleComposerType]
          }
          handleSelect={handleSelect}
          rowHeight={40}
          visibleRowSize={4}
          key={'doc-field-search'}
        />
      </div>
    </div>
  );
};

export default SearchBox;
